import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";
import { detectPlatform, isStandalone } from "@/lib/device";

const FLAG = "td_app_visit_recorded";

function detectMode(): "standalone" | "browser" {
  return isStandalone() ? "standalone" : "browser";
}

/** Фоновая телеметрия: раз за сессию вкладки отмечает визит и режим запуска. */
export function useAppVisit() {
  const { user, isLoading } = useAuth();
  useEffect(() => {
    if (isLoading || !user?.id) return;
    try {
      if (sessionStorage.getItem(FLAG)) return;
    } catch {
      /* ignore */
    }
    (async () => {
      try {
        const { data } = await supabase.auth.getSession();
        if (!data.session) return;
        const { error } = await supabase.rpc("record_app_visit", {
          p_display_mode: detectMode(),
          p_platform: detectPlatform(),
        });
        if (!error) {
          try {
            sessionStorage.setItem(FLAG, "1");
          } catch {
            /* ignore */
          }
        }
      } catch {
        /* фоновая телеметрия — молча */
      }
    })();
  }, [user?.id, isLoading]);
}
